import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { UiService } from '@services/ui.service';
import { AddressGroupsService } from '@services/address-groups.service';
import { Address } from '@classes/address';
import { AddressGroup } from '@classes/address-group';
import { Site } from '@classes/site';
import { SiteGroup } from '@classes/site-group';

@Component({
  selector: 'app-address-group-edit',
  templateUrl: './address-group-edit.component.html',
  styleUrls: ['./address-group-edit.component.scss'],
})
export class AddressGroupEditComponent
  extends FormEditBaseComponent
  implements OnInit
{
  @Input() addressGroup: AddressGroup;
  @Input() addresses: Address[] = [];
  @Input() sites: Site[] = [];
  @Input() siteGroups: SiteGroup[] = [];

  stringMaxLength = 50;

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private addressGroupsSrv: AddressGroupsService,
  ) {
    super(uiSrv, fb);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initForm();
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.addressGroup) {
      this.update();
    } else {
      this.create();
    }
  }

  onCancel(): void {
    this.editFinished.emit();
  }

  endForm(response: boolean) {
    if (response) {
      this.onSubmit();
    } else {
      this.onCancel();
    }
  }

  private update(): void {
    const addressGroupCopy: AddressGroup = JSON.parse(
      JSON.stringify(this.addressGroup),
    );
    addressGroupCopy.name = this.editForm.value.name;
    addressGroupCopy.addressIds = this.getSelectedIds('addresses');
    addressGroupCopy.siteIds = this.getSelectedIds('sites');
    addressGroupCopy.siteGroupIds = this.getSelectedIds('siteGroups');
    addressGroupCopy.addresses = [];
    addressGroupCopy.sites = [];
    addressGroupCopy.siteGroups = [];

    this.addressGroupsSrv
      .put(addressGroupCopy)
      .subscribe(() => (this.isLoading = false));
  }

  private create(): void {
    this.addressGroup = new AddressGroup(
      this.editForm.value.name,
      this.getSelectedIds('addresses'),
      this.getSelectedIds('sites'),
      this.getSelectedIds('siteGroups'),
    );

    this.addressGroupsSrv.post(this.addressGroup).subscribe(
      () => (this.isLoading = false),
      () => (this.addressGroup = null),
    );
  }

  private getSelectedIds(controlName: string): string[] {
    return this.editForm.value[controlName].map((item) => item.id);
  }

  private initForm(): void {
    let name = '';
    let addresses: Address[] = [];
    let sites: Site[] = [];
    let siteGroups: SiteGroup[] = [];

    if (this.addressGroup) {
      name = this.addressGroup.name;
      addresses = this.addressGroup.addresses || [];
      sites = this.addressGroup.sites || [];
      siteGroups = this.addressGroup.siteGroups || [];
    }

    this.editForm = this.fb.group({
      name: [
        name,
        [Validators.required, Validators.maxLength(this.stringMaxLength)],
      ],
      addresses: [addresses, Validators.required],
      sites: [sites],
      siteGroups: [siteGroups],
    });
  }
}
